import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGauge,
  faUsers,
  faHeart,
  faShieldHalved,
  faBuilding,
  faUserPlus,
  faFileLines,
  faCreditCard,
  faTicket,
  faBell,
  faSlidersH,
  faDatabase,
  faUserShield,
  faClipboardList,
  faComments,
  faRightFromBracket,
  faBars,
  faXmark,
  faCircleCheck,
  faChartLine,
  faTag,
  faRocket,
  faBrain,
  faBoltLightning,
  faBox,
  faScaleBalanced,
  faCalendarXmark,
  faLink,
  faMoon,
  faSun,
  faTrophy,
  faCamera,
  faFingerprint,
  faShield,
  faChartBar,
  faSearch,
  faCalendarDays,
  faIndianRupeeSign,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import logo from "../../assets/Mobile logo monogram - L.png";
import "./sidebar.css";

const NAV = [
  {
    section: "Overview",
    items: [
      { label: "Dashboard", icon: faGauge, path: "command-dashboard", module: "Dashboard" },
      { label: "Engagement Analytics", icon: faChartLine, path: "engagement-analytics", module: "Dashboard" },
      { label: "Status Analytics", icon: faFingerprint, path: "status-analytics", module: "Dashboard" },
      { label: "Status Manager", icon: faShield, path: "status-manager", module: "Dashboard" },
    ],
  },
  {
    section: "Users",
    items: [
      { label: "Global Search", icon: faSearch, path: "global-search", module: "MatchSeekers" },
      { label: "Match Seekers", icon: faUsers, path: "user-management/match-seekers/list", module: "MatchSeekers" },
      { label: "BG Profiles", icon: faHeart, path: "user-management/bride-groom-profile/list", module: "Bride/GroomProfile" },
      { label: "Verification", icon: faCircleCheck, path: "user-management/verification/list", module: "ProfileVerification" },
      { label: "Reports", icon: faFileLines, path: "user-management/reports/list", module: "Reports" },
      { label: "Connects", icon: faLink, path: "connects/list", module: "Connects" },
      { label: "Match Log", icon: faHeart, path: "match-log", module: "Match Log" },
      { label: "Match Closures", icon: faTrophy, path: "match-closures", module: "Match Log" },
      { label: "2nd Marriage Pool", icon: faHeart, path: "second-marriage-pool", module: "Bride/GroomProfile" },
    ],
  },
  {
    // The bureau rails get their own section rather than living under Events:
    // a matchmaker exists independently of any Meet, and verifying her is what
    // unlocks hosting in the first place.
    section: "MatchMatrix Bureau",
    items: [
      { label: "Bureaus", icon: faBuilding, path: "bureau/list", module: "Bureau" },
      { label: "Intakes", icon: faFileLines, path: "bureau/intakes", module: "Bureau" },
      { label: "Referrals", icon: faUserPlus, path: "bureau/referrals", module: "Bureau" },
      { label: "Consent Lookup", icon: faShieldHalved, path: "bureau/consent", module: "Bureau" },
    ],
  },
  {
    section: "Events",
    items: [
      { label: "Events", icon: faCalendarDays, path: "events/list", module: "Events" },
      { label: "Matchmaker Earnings", icon: faIndianRupeeSign, path: "events/earnings", module: "Events" },
    ],
  },
  {
    section: "Revenue",
    items: [
      { label: "Subscriptions", icon: faCreditCard, path: "manage-subscription/list", module: "ManageSubscriptionPlan" },
      { label: "Pricing Dashboard", icon: faTag, path: "pricing-dashboard", module: "ManageConnectsPricing" },
      { label: "Pack Purchases", icon: faCreditCard, path: "payments/pack-purchases/list", module: "Payment History" },
      { label: "Promo Codes", icon: faTicket, path: "promo-codes/list", module: "CouponsAndDiscounts" },
      { label: "Influencer Hub", icon: faChartLine, path: "influencer-hub", module: "CouponsAndDiscounts" },
    ],
  },
  {
    section: "User Packs",
    items: [
      { label: "Pack Manager", icon: faBox, path: "user-pack-manager", module: "ManageSubscriptionPlan" },
      { label: "Subscription Expiry", icon: faCalendarXmark, path: "subscription-expiry", module: "ManageSubscriptionPlan" },
      { label: "Reconciliation", icon: faScaleBalanced, path: "payment-reconciliation", module: "Payment History" },
      { label: "Users by Pack", icon: faUsers, path: "pack-users", module: "ManageSubscriptionPlan" },
    ],
  },
  {
    section: "Communications",
    items: [
      { label: "Push Notifications", icon: faBell, path: "notifications/broadcast", module: "NotificationAndAlerting" },
      { label: "Notification Analytics", icon: faChartBar, path: "notifications/hub", module: "NotificationAndAlerting" },
      { label: "Triggers", icon: faBoltLightning, path: "notification-triggers", module: "NotificationAndAlerting" },
      { label: "Support", icon: faComments, path: "logs/support/list", module: "Support" },
    ],
  },
  {
    section: "Platform",
    items: [
      { label: "App Config", icon: faSlidersH, path: "app-config", module: "MasterDataManagement" },
      { label: "Master Data", icon: faDatabase, path: "master-data-management/list", module: "MasterDataManagement" },
      { label: "Boost Console", icon: faRocket, path: "boost-console", module: "ManageSubscriptionPlan" },
      { label: "Alignment Questions", icon: faBrain, path: "alignment-questions", module: "ContentManagement" },
    ],
  },
  {
    section: "Administration",
    items: [
      { label: "Staff Access", icon: faUserShield, path: "staff-access-management/list", module: "StaffAccessManagement" },
      { label: "Audit Log", icon: faClipboardList, path: "audit-log", module: "ComplianceAndGovernance" },
      { label: "Fraud & Refunds", icon: faShieldHalved, path: "fraud-refunds", module: "ComplianceAndGovernance" },
      { label: "Photo Moderation", icon: faCamera, path: "photo-moderation", module: "ComplianceAndGovernance" },
    ],
  },
];

const AppSidebar = ({ isOpen, toggleSidebar, dark, toggleDark }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("UD") || "{}");
  const isAdmin = user?.staffType === "Admin";
  const accessModules = user?.accessModules || [];

  const canAccess = (module) => !module || isAdmin || accessModules.includes(module);

  const isActive = (path) => location.pathname.includes(path);

  const handleSignOut = () => {
    localStorage.clear();
    toast.success("Signed out");
    navigate("/login");
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-20 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-screen z-30 flex flex-col transition-all duration-300 ease-in-out
          ${isOpen ? "w-60" : "w-16"}`}
        style={{ background: "linear-gradient(180deg, #0F172A 0%, #1E293B 100%)", borderRight: "1px solid rgba(255,255,255,0.06)" }}
      >
        {/* Logo row */}
        <div className="flex items-center gap-3 px-4 py-5 border-b border-white/5 flex-shrink-0">
          <img src={logo} alt="MatchMatrix" className="w-8 h-8 flex-shrink-0 rounded-lg" />
          {isOpen && (
            <div className="overflow-hidden">
              <p className="text-white font-bold text-sm leading-tight tracking-wide">MatchMatrix</p>
              <p className="text-white/40 text-xs">Admin Panel</p>
            </div>
          )}
          <button
            onClick={toggleSidebar}
            className="ml-auto text-white/40 hover:text-white transition p-1 rounded"
          >
            <FontAwesomeIcon icon={isOpen ? faXmark : faBars} className="text-sm" />
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 overflow-y-auto py-3 px-2 space-y-5 scrollbar-hide">
          {NAV.map((group) => {
            const visibleItems = group.items.filter((item) => canAccess(item.module));
            if (visibleItems.length === 0) return null;
            return (
              <div key={group.section}>
                {isOpen && (
                  <p className="text-white/25 text-[10px] font-semibold uppercase tracking-widest px-2 mb-1">
                    {group.section}
                  </p>
                )}
                <div className="space-y-0.5">
                  {visibleItems.map((item) => {
                    const active = isActive(item.path);
                    return (
                      <Link
                        key={item.path}
                        to={`/${item.path}`}
                        className={`flex items-center gap-3 px-2 py-2 rounded-lg transition-all duration-150 group
                          ${active
                            ? "bg-[#C9A84C]/15 text-[#C9A84C]"
                            : "text-white/50 hover:text-white hover:bg-white/5"
                          }`}
                      >
                        <div className={`w-7 h-7 flex items-center justify-center rounded-md flex-shrink-0 transition-all
                          ${active ? "bg-[#C9A84C]/20" : "group-hover:bg-white/5"}`}>
                          <FontAwesomeIcon icon={item.icon} className="text-sm" />
                        </div>
                        {isOpen && (
                          <span className="text-sm font-medium truncate">{item.label}</span>
                        )}
                        {active && isOpen && (
                          <div className="ml-auto w-1.5 h-1.5 rounded-full bg-[#C9A84C] flex-shrink-0" />
                        )}
                      </Link>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </nav>

        {/* User / Sign out */}
        <div className="border-t border-white/5 p-3 flex-shrink-0">
          {isOpen ? (
            <div className="flex items-center gap-3 px-2 py-2">
              <div className="w-8 h-8 rounded-full bg-[#C9A84C]/20 flex items-center justify-center flex-shrink-0">
                <span className="text-[#C9A84C] text-xs font-bold">
                  {(user?.name || user?.emailId || "A")[0].toUpperCase()}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-white text-xs font-medium truncate">{user?.name || "Admin"}</p>
                <p className="text-white/30 text-[10px] truncate">{user?.emailId || ""}</p>
              </div>
              <button
                onClick={toggleDark}
                title={dark ? "Switch to light mode" : "Switch to dark mode"}
                className="text-white/30 hover:text-yellow-300 transition p-1"
              >
                <FontAwesomeIcon icon={dark ? faSun : faMoon} className="text-sm" />
              </button>
              <button
                onClick={handleSignOut}
                title="Sign out"
                className="text-white/30 hover:text-red-400 transition p-1"
              >
                <FontAwesomeIcon icon={faRightFromBracket} className="text-sm" />
              </button>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-2 py-2">
              <button
                onClick={toggleDark}
                title={dark ? "Switch to light mode" : "Switch to dark mode"}
                className="text-white/30 hover:text-yellow-300 transition p-1"
              >
                <FontAwesomeIcon icon={dark ? faSun : faMoon} className="text-sm" />
              </button>
              <button
                onClick={handleSignOut}
                title="Sign out"
                className="text-white/30 hover:text-red-400 transition p-1"
              >
                <FontAwesomeIcon icon={faRightFromBracket} className="text-sm" />
              </button>
            </div>
          )}
        </div>
      </aside>
    </>
  );
};

export default AppSidebar;
